import script from "./ProgramVersionBenchmarkForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgramVersionBenchmarkForm.vue?vue&type=script&setup=true&lang=ts"

import "./ProgramVersionBenchmarkForm.vue?vue&type=style&index=0&id=69d9bd4e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69d9bd4e"]])

export default __exports__